import * as React from "react"
import { translateCountryName } from "@ui-seeker/utils"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { LabelCountry } from "@components"
import { BACKEND_APIS } from "@constants"
import { selectedMarkets, selectedSites } from "../@signals"


export default function ScrapingDataReviewMarketFilter() {
    return <AutocompleteAjaxSeeker
        multiple
        urlAjax={`${BACKEND_APIS.SCRAPING_DATA_REVIEW}/markets`}
        label="Market"
        placeholder="All Markets"
        value={selectedMarkets.value}
        onChange={e => {
            selectedMarkets.value = e.target.value
            // The site list is market-scoped, so a market change invalidates
            // whatever was chosen from the old one. Leaving it empty is fine
            // now: the market alone searches every site in it.
            selectedSites.value = []
        }}
        getOptionLabel={({ label }) => translateCountryName(label)}
        formatOptionLabel={({ label }) => <LabelCountry country={label} label={translateCountryName(label)} />}
    />
}
